import { defineMessages } from 'react-intl';

const messages = defineMessages({
  customContentType: {
    description: 'bulkActionsCustomsDeclarations.customContentType',
    defaultMessage: 'Custom Content Type',
    id: 'ZWeHs9',
  },
  selectContentType: {
    description: 'bulkActionsCustomsDeclarations.selectContentType',
    defaultMessage: 'Select Content Type',
    id: 'uw/5s9',
  },
  ifNonDelivery: {
    description: 'bulkActionsCustomsDeclarations.ifNonDelivery',
    defaultMessage: 'If Non-Delivery',
    id: 'qwOaKp',
  },
  selectNonDelivery: {
    description: 'bulkActionsCustomsDeclarations.selectNonDelivery',
    defaultMessage: 'Select Non-Delivery',
    id: 'F67+x+',
  },
  noteType: {
    description: 'bulkActionsAddNote.noteType',
    defaultMessage: 'Note Type',
    id: 'qPF53J',
  },
  pleaseSelect: {
    description: 'bulkActionsAddNote.pleaseSelect',
    defaultMessage: 'Please Select',
    id: 'NFgi2a',
  },
  addNoteMessage: {
    description: 'bulkActionsAddNote.noteMessage',
    defaultMessage: 'If you already have {noteType}, this will overwrite the existing note.',
    id: 'c4/GZm',
  },
  shipByDateLabel: {
    description: 'shipByBulk.label',
    defaultMessage: 'Set Ship By Date with',
    id: 'EF2VHQ',
  },
  shipByDateExactDateRadioLabel: {
    description: 'shipByBulk.exactDateRadioLabel',
    defaultMessage: 'Exact date',
    id: 'b/rYiu',
  },
  shipByDateDaysAfterOrderDateRadioLabel: {
    description: 'shipByBulk.daysAfterOrderDateRadioLabel',
    defaultMessage: 'Days after the order date',
    id: 'uiAcBZ',
  },
  shipByDateDaysInputLabel: {
    description: 'shipByBulk.daysInputLabel',
    defaultMessage: 'days',
    id: 'sQvPv3',
  },
  serviceUpdateNotAllowedError: {
    description: 'shipByBulk.service.notAllowedError',
    defaultMessage: 'Ship From must be set to the same Fulfillment Provider to bulk update Service on selected orders',
    id: 'n2jr/Z',
  },
  shipByDateRequired: {
    description: 'shipByBulk.dateRequiredError',
    defaultMessage: 'Date is Required.',
    id: '1PFcT0',
  },
  shipByDaysRequired: {
    description: 'shipByBulk.daysRequiredError',
    defaultMessage: 'Number of Days is Required.',
    id: 'c0OsoM',
  },
});

export default messages;
